<template>
  <div class="row">
    <div class="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2 col-xl-6 offset-xl-3">
      <card class="card">
        <div class="card-body">
          <div class="text-danger text-center" style="font-size:40px;"><span class="ti-alert"></span></div>
          <h4 class="card-title mb-4 text-center">Η πληρωμή δεν ολοκληρώθηκε</h4>
          <h5 v-if="failureReasonsFetched && errorMessage" class="text-center text-muted">Μήνυμα σφάλματος:</h5>
          <div v-if="errorMessage" class="text-center text-muted">{{ errorMessage }}</div>
          <input type="hidden" id="failure-reason-id" :value="$route.query.eventId">
        </div>
      </card>
      <div class="text-center"><router-link :to="{path:'/plans'}">νέα προσπάθεια</router-link></div>
    </div>
  </div>
</template>
<script>
import Api from "../api";
export default {
  components: {
    
  },
  data() {
    return {
      failureReasonsFetched: false,
      errorMessage: null
    };
  },
  mounted() {
    this.getFailureReasons();
  },
  methods: {
    getFailureReasons () {
      let self = this;
      Api.send("GET", "/payments/viva/failure_reasons", {})
        .then((response) => {
          const eventId = parseInt(document.getElementById('failure-reason-id').value);
          self.errorMessage = (response[eventId]) ? response[eventId] : 'Απροσδιόριστο σφάλμα';
        })
        .catch((err) => {
          self.errorMessage = null;
        })
        .finally(() => {
          self.failureReasonsFetched = true;
        });
    },
  },
};
</script>
<style scoped>
</style>
